import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";

const TripReviewBackButton = (props) => (
  <Link
    to={`${process.env.PUBLIC_URL}/vtr-trip-review`}
    state={{
      trip_id: props.trip_id,
      client_id: props.client_id,
    }}
  >
    <Button
      type="submit"
      variant="contained"
      color="primary"
      fullWidth
      className="form-input"
      style={{ marginBottom: 20 }}
      size="large"
    >
      Cancel
    </Button>
  </Link>
);

export default TripReviewBackButton;
